// extracted by mini-css-extract-plugin
export default {"root":"_1Ewm6noJ","prefix":"_3fyd_hRF","active":"_1SvNJAbQ","avatar":"lMlUbShp","label":"_13ocjs2K","count":"_2c0ebXSh"};